<form [formGroup]="form" class="form__wrapper">

    <div formGroupName="scheduleMethod">
        <!-- Schedule method selection -->
        <div class="form__field-row playing-type" [class.hidden]="isHotPlaylist">
            <mat-form-field>
                <mat-select formControlName="scheduleType"
                            placeholder="{{'app.schedulePage.playingType' | translate}}">
                    <mat-option *ngFor="let type of scheduleTypes | keyvalue"
                                [value]="type.value">
                        <span>{{'app.schedulePage.' + type.value | translate}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <!--  End schedule method selection -->

        <!-- Start-Ends method -->
        <div class="form__field-row start-ends"
             [hidden]="!(form.controls.scheduleMethod.get('scheduleType')?.value === scheduleTypes.period)"
        >
            <div formGroupName="period" class="flex space-between">
                <div class="form__input-wrapper calendar-icon">
                    <ng2-flatpickr #startPicker [config]="dateTimeOptions" formControlName="start"
                                   placeholder="{{'app.schedulePage.start' | translate}}"></ng2-flatpickr>

                    <mat-error *ngIf="form.controls.scheduleMethod.get('period.start')?.touched && form.controls.scheduleMethod.get('period.start')?.invalid">
                        <span *ngIf="form.controls.scheduleMethod.get('period.start')?.errors">{{'errors.chooseDate' | translate}}</span>
                    </mat-error>
                </div>
                <div class="form__input-wrapper calendar-icon">
                    <ng2-flatpickr  #endPicker [config]="dateTimeOptions" formControlName="end"
                                    placeholder="{{'app.schedulePage.end' | translate}}"></ng2-flatpickr>

                    <mat-error *ngIf="form.controls.scheduleMethod.get('period.end')?.touched && form.controls.scheduleMethod.get('period.end')?.invalid">
                        <span *ngIf="form.controls.scheduleMethod.get('period.end')?.errors">{{'errors.chooseDate' | translate}}</span>
                    </mat-error>
                </div>
            </div>
            <mat-error *ngIf="form.errors?.message">
                <span>{{'errors.repeatSegment' | translate}}</span>
            </mat-error>
            <mat-error *ngIf="form.get('scheduleMethod.period')?.errors?.diffDates">
                <span>{{'errors.afterStart' | translate}}</span>
            </mat-error>
        </div>
        <!-- End start-ends method -->

        <!-- ALl day method -->
        <div class="form__field-row all-day" formGroupName="allday"
             [hidden]="!(form.controls.scheduleMethod.get('scheduleType')?.value === scheduleTypes.allday)"
        >
            <div class="calendar-icon">
                <ng2-flatpickr #allDayPicker class="all-day" [config]="dateOptions" formControlName="date"
                               placeholder="Date"></ng2-flatpickr>
                <mat-error *ngIf="form.get('scheduleMethod.allday.date')?.touched && form.get('scheduleMethod.allday.date')?.invalid">
                    <span *ngIf="form.get('scheduleMethod.allday.date')?.errors">{{'errors.chooseDate' | translate}}</span>
                </mat-error>
            </div>
        </div>
        <!-- End all day method -->
    </div>

    <div formGroupName="repetitionMethod">

        <div class="form__field-row"
             [hidden]="!(form.controls.scheduleMethod.get('scheduleType')?.value === scheduleTypes.period)"
        >
            <mat-form-field>
                <mat-select
                        placeholder="{{'app.schedulePage.repeat' | translate}}"
                        formControlName="repetitionType"
                >
                    <mat-option *ngFor="let type of repetitionTypes | keyvalue"
                                [value]="type.value">
                        <span>{{'app.schedulePage.' + type.value | translate}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!--  Days of week method-->
        <div class="form__field-row week-days"
             [hidden]="!(form.controls.repetitionMethod.get('repetitionType')?.value === repetitionTypes.weekDays &&
         form.controls.scheduleMethod.get('scheduleType')?.value === scheduleTypes.period)">
            <div class="flex">
                <div class="week-days-item" *ngFor="let day of weakDays">
                    <input type="checkbox"
                           [checked]="day | checkValueInArray: this.form.get('repetitionMethod.weekDays.daysOfWeek')?.value"
                           [value]="day" [id]="day" (change)="onCheckBoxDayChange($event)">
                    <label [for]="day">{{'app.days.' + day | translate}}</label>
                </div>
            </div>
            <mat-error *ngIf="form.get('repetitionMethod.weekDays.daysOfWeek')?.touched && form.get('repetitionMethod.weekDays.daysOfWeek')?.invalid">
                <span *ngIf="form.get('repetitionMethod.weekDays.daysOfWeek')?.errors">{{'errors.chooseDays' | translate}}</span>
            </mat-error>
            <div class="calendar-icon" formGroupName="weekDays">
                <ng2-flatpickr #endDateWeek [config]="dateOptions" formControlName="endDate"
                               placeholder="{{'app.schedulePage.endsOn' | translate}}"></ng2-flatpickr>
                <mat-error *ngIf="form.get('repetitionMethod.weekDays.endDate')?.touched && form.get('repetitionMethod.weekDays.endDate')?.invalid">
                    <span *ngIf="form.get('repetitionMethod.weekDays.endDate')?.errors">{{'errors.chooseDate' | translate}}</span>
                </mat-error>
            </div>
        </div>
        <!--  End Days of week method-->

        <!-- Specific days repetition method -->
        <div class="form__field-row specific-days"
             formGroupName="specificDates"
             [hidden]="!(form.controls.repetitionMethod.get('repetitionType')?.value === repetitionTypes.specificDates &&
         form.controls.scheduleMethod.get('scheduleType')?.value === scheduleTypes.period)"
        >
            <mat-form-field>
                <mat-label>{{'app.schedulePage.repeatEvery' | translate}}</mat-label>
                <input class="total-days" type="number" min="1" max="366" matInput formControlName="totalDays">
                <mat-error *ngIf="form.get('repetitionMethod.specificDates.totalDays')?.touched && form.get('repetitionMethod.specificDates.totalDays')?.invalid">
                    <span *ngIf="form.get('repetitionMethod.specificDates.totalDays')?.errors?.required">{{'errors.requiredField' | translate}}</span>
                </mat-error>
                <mat-error *ngIf="form.get('repetitionMethod.specificDates.totalDays')?.touched && form.get('repetitionMethod.specificDates.totalDays')?.invalid">
                    <span *ngIf="form.get('repetitionMethod.specificDates.totalDays')?.errors?.min">{{'errors.minDays' | translate}}</span>
                </mat-error>
            </mat-form-field>
            <div class="calendar-icon">
                <ng2-flatpickr #endDateSpecific  [config]="dateOptions" formControlName="endDate"
                               placeholder="{{'app.schedulePage.endsOn' | translate}}"></ng2-flatpickr>
                <mat-error *ngIf="form.get('repetitionMethod.specificDates.endDate')?.touched && form.get('repetitionMethod.specificDates.endDate')?.invalid">
                    <span *ngIf="form.get('repetitionMethod.specificDates.endDate')?.errors">{{'errors.chooseDate' | translate}}</span>
                </mat-error>
            </div>
        </div>
        <!--  End specific days repetition method-->
    </div>
</form>
